import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { TipoCombustibleModel } from '../../models/tipo-combustible.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoCombustibleService extends BaseService<TipoCombustibleModel>{

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Tipo combustible';
    this.urlBase = `${environment.baseApi}${environment.endPoints.maestras.base_maestra}${environment.endPoints.maestras.tipoCombustible}`;
   }
}
